import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "col q-px-md q-py-sm" }

import {
  SFX_CARD_HEIGHT,
  SFX_CARD_IMG_WIDTH,
  SKELETON_ANIMATION,
} from "src/util/constants/configurations"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSkeleton',
  props: {
  height: {
    type: Number,
    default: SFX_CARD_HEIGHT,
  },

  hasImg: {
    type: Boolean,
    default: true,
  },

  noOfCards: {
    type: Number,
    default: 10,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const cardHeight = computed(() => props.height.toString() + "px")

const cardStyles = computed(() => {
  return {
    "max-height": cardHeight.value,
  }
})

// Subtract 4px because of the card's borders (2px each)
const imgHeight = String(props.height - 4) + "px"

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.noOfCards, (index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "q-my-md"
    }, [
      _createVNode(_component_q_card, {
        bordered: "",
        flat: "",
        class: "sfx-card-skeleton",
        style: _normalizeStyle(cardStyles.value),
        height: imgHeight
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-start no-wrap q-pa-none" }, {
            default: _withCtx(() => [
              (props.hasImg)
                ? (_openBlock(), _createBlock(_component_q_skeleton, {
                    key: 0,
                    class: "sfx-card-skeleton-image",
                    width: _unref(SFX_CARD_IMG_WIDTH),
                    height: imgHeight,
                    square: "",
                    animation: _unref(SKELETON_ANIMATION)
                  }, null, 8, ["width", "animation"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_skeleton, {
                  type: "text",
                  square: "",
                  class: "text-subtitle2",
                  width: "70%",
                  animation: _unref(SKELETON_ANIMATION)
                }, null, 8, ["animation"]),
                _createVNode(_component_q_skeleton, {
                  type: "text",
                  square: "",
                  class: "text-h4",
                  width: "100%",
                  animation: _unref(SKELETON_ANIMATION)
                }, null, 8, ["animation"]),
                _createVNode(_component_q_skeleton, {
                  type: "text",
                  square: "",
                  class: "text-caption",
                  width: "70%",
                  animation: _unref(SKELETON_ANIMATION)
                }, null, 8, ["animation"]),
                _createVNode(_component_q_skeleton, {
                  type: "text",
                  square: "",
                  class: "text-body2",
                  width: "100%",
                  animation: _unref(SKELETON_ANIMATION)
                }, null, 8, ["animation"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]))
  }), 128))
}
}

})